export function NoDataSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/no-data.svg'"></ng-include>`
    }
}